import React from 'react';
import PropTypes from 'prop-types';

import {
  faCocktail,
  faWarehouse,
  faShoppingBasket,
  faDesktop,
  faWineGlass,
  faTruck,
  faPlaneDeparture,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const typeIconMap = {
  horeca: faCocktail,
  dvh: faShoppingBasket,
  wholesale: faWarehouse,
  office: faDesktop,
  systembolaget: faWineGlass,
  supplier: faTruck,
  export: faPlaneDeparture,
  other: faQuestion,
};

const widthSizes = {
  lg: '70px',
  md: '45px',
  sm: '25px',
};
const heightSizes = {
  lg: '65px',
  md: '40px',
  sm: '20px',
};

const iconSizeValue = {
  lg: '3x',
  md: '2x',
  sm: '1x',
};

const classNames = {
  lg: 'm-1 mt-2',
  md: 'mt-1',
};

export default class CustomerTypeIcon extends React.PureComponent {
  static get propTypes() {
    return {
      entity: PropTypes.object.isRequired,
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      bgColor: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      size: 'lg',
      bgColor: 'light',
    };
  }

  render() {
    const { entity, size, bgColor } = this.props;
    const { customerType } = entity;
    const icon = typeIconMap[customerType] || faQuestion;

    return (
      <div
        className={`bg-${bgColor} text-secondary rounded mt-1`}
        style={{
          width: widthSizes[size],
          height: heightSizes[size],
          textAlign: 'center',
        }}
      >
        <FontAwesomeIcon
          className={classNames[size]}
          icon={icon}
          size={iconSizeValue[size]}
        />
      </div>
    );
  }
}
